import React from 'react';
import { styled } from '@mui/material/styles';
import CookiePolicyContent from './components/CookiePolicyContent';
import { Fade } from '@mui/material';
import { APP_FADE_TIMEOUT } from '../../constants/AppConstants';
import { Container, Typography } from '@mui/material';

const CookiePolicyRoot = styled('div')(({ theme }) => ({
    
}));

const CookiePolicyHeader = styled('div')(({ theme }) => ({
    backgroundColor: '#F8F9FA',
    padding: '50px 0',
    textAlign: 'center',
}));


const CookiePolicy = () => {
    return (
        <Fade in={true} timeout={APP_FADE_TIMEOUT}>
            <CookiePolicyRoot>

                <CookiePolicyHeader>
                    <Container maxWidth="lg">
                        <Typography variant="h1" style={{ margin: '0 auto', fontSize: '46px' }}>
                            Cookie Policy
                        </Typography>
                    </Container>                    
                </CookiePolicyHeader>

                <CookiePolicyContent />

            </CookiePolicyRoot>
        </Fade>
    );
};

export default CookiePolicy;
